import { CmsIcon } from '@domgen/dgx-fe-cms';
import { NavigationLink } from '@domgen/dgx-fe-common';

export interface ContactUsPanel {
  body: string;
  icon: CmsIcon;
  link: NavigationLink;
  title: string;
}
